// extracted by mini-css-extract-plugin
module.exports = {"container":"block-documents_container__P2siH"};